<template functional>
  <div
    class="inline-flex flex-col"
    v-bind="attrs"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data)"
    v-on="listeners"
  >
    <span
      class="text-sm font-bold tracking-wider text-gray-500 uppercase"
      v-text="props.label"
    />
    <span
      class="text-xl"
    >
      <slot />
    </span>
  </div>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  name: 'MiaCarEditLabelledText',

  props: {
    label: {
      type: String,
      required: true
    }
  },

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
